module.exports = __webpack_public_path__ + "img/check.67c77aca.svg";